import debounce from "lodash/debounce"
import Component from "../core/Component"
import { substitute } from "../utils/String"
import Scroll from "../services/Scroll"
import { queries } from "../core/config"

const STATES = {
    VIDEO_READY: "is-video-ready",
}
export default class Video extends Component {
    constructor(element, options = {}) {
        super(
            element,
            (options = {
                sizes: {},
            })
        )

        this.ref = {
            template: null,
            inner: null,
        }

        this.template = this.ref.template.innerHTML.trim()
        this.video = null
        this.lastClosestWidth = null
    }

    prepare() {
        this.resize()
        Scroll.on("resize-x", this.handleResize)
    }

    destroy() {
        Scroll.off("resize-x", this.handleResize)
    }

    handleResize = () => {
        this.debounceResize()
    }

    debounceResize = debounce(this.resize, 500)

    resize() {
        const sizes = this.getSizesForCurrentViewport()
        const rect = this.ref.inner.getBoundingClientRect()
        const desiredWidth = isRetina() ? rect.width * 2 : rect.width
        const closestWidth = closestNumInArray(
            desiredWidth,
            Object.keys(sizes).map((width) => parseInt(width))
        )
        if (!closestWidth || this.lastClosestWidth === closestWidth) {
            return
        }
        this.element.classList.remove(STATES.VIDEO_READY)

        const previousState = this.video
            ? {
                  isPlaying: !!(
                      this.video.currentTime > 0 &&
                      !this.video.paused &&
                      !this.video.ended &&
                      this.video.readyState > 2
                  ),
                  currentTime: this.video.currentTime ?? 0,
              }
            : null

        this.ref.inner.innerHTML = substitute(this.template, {
            source: `<source src="${sizes[closestWidth]}" type="video/mp4">`,
        })
        this.video = this.element.querySelector("video")

        if (previousState) {
            if (previousState.currentTime) {
                this.video.currentTime = previousState.currentTime
            }
            if (previousState.isPlaying) {
                this.video.play()
            }
        }

        this.lastClosestWidth = closestWidth
        this.element.classList.add(STATES.VIDEO_READY)
    }

    getSizesForCurrentViewport() {
        const breakpointSizes = Object.entries(this.options).reduce((acc, [breakpoint, option]) => {
            if (window.matchMedia(queries[breakpoint]).matches) {
                if (!acc) {
                    acc = {}
                }
                acc = {
                    ...acc,
                    ...option,
                }
            }
            return acc
        }, null)
        return breakpointSizes ? breakpointSizes : this.options.sizes
    }

    play() {
        if (this.video) {
            this.video.play()
        }
    }

    clear() {
        this.lastClosestWidth = null
        if (this.video) {
            this.video.pause()
        }
        // this.element.classList.remove(STATES.VIDEO_READY)
    }
}

function closestNumInArray(desiredNumber, numbers) {
    return numbers.reduce(function (prev, curr) {
        return Math.abs(curr - desiredNumber) < Math.abs(prev - desiredNumber) ? curr : prev
    })
}

function isRetina() {
    var mediaQuery =
        "(-webkit-min-device-pixel-ratio: 1.5),\
					  (min--moz-device-pixel-ratio: 1.5),\
					  (-o-min-device-pixel-ratio: 3/2),\
					  (min-resolution: 1.5dppx)"

    if (window.devicePixelRatio > 1) return true

    if (window.matchMedia && window.matchMedia(mediaQuery).matches) return true

    return false
}
